const modalTriggers = Array.from(document.querySelectorAll('.modal-open'));
const modal = document.getElementById("modal");
const closeBtn = modal ? modal.querySelector('.modal-close') : null;

const hasModalTriggers = () => modalTriggers.length > 0 && modal !== null;

window.addEventListener('load', () => {
  if (hasModalTriggers()) {
    modalOpen();
    modalClose();
    modalDismiss();
  }
});

const modalOpen = () => {
  modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      modal.style.display = 'block';
    });
  });
};

const modalClose = () => {
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });
  }
};

const modalDismiss = () => {
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.style.display = 'none';
      }
    });
  }
};
